import * as React from "react";

function Candidates({color="var(--color-blue-500)",...props}) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M11.678 4.922c0 2.212-1.735 4-3.883 4-2.147 0-3.883-1.788-3.883-4 0-2.212 1.736-4 3.883-4 2.14 0 3.883 1.788 3.883 4z"
        stroke={color}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 15.717a6.795 6.795 0 016.795-6.795v0a6.795 6.795 0 016.796 6.795v3.205H1v-3.205z"
        stroke={color}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.047 17.922h1.984c.524 0 .963-.404.968-.928.047-4.548-2.223-6.603-3.437-7.072.809-1.333 1.65-4.3-1.457-5.5"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Candidates;
